<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid, dirty }"
  >
    <NavTabs
      customClass="capitalize_title"
      :tabs="tabs"
      :activeTab="newActiveTab"
      @sendData="updateData"
    />

    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirtyChanged', dirty)"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('validChanged', valid)"
    />
  </ValidationObserver>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import NavTabs from '@/components/shared/widgets/Nav-tabs.vue';
import History from '@/components/forms/technicalFile/closedLoop/forms/History';
import System from '@/components/forms/technicalFile/closedLoop/forms/System';
import Filtration from '@/components/forms/technicalFile/closedLoop/forms/Filtration';
import Treatment from '@/components/forms/technicalFile/closedLoop/forms/Treatment';
import lockService from '@/utilities/lockService';


export default {
    components: {
        ValidationObserver,
        SlotScopeWatcher,
        NavTabs,
    },
    props: {
        node: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            tabs: [],
            components: [System, Filtration, Treatment, History],
            empty: {
                system: {
                    name: '',
                    type: null,
                    operation: null,
                    fluid: null,
                    operatingTemperature: {
                        value: null,
                        units: null,
                    },
                    volume: {
                        value: null,
                        units: null,
                    },
                    averageMakeup: {
                        value: null,
                        units: null,
                    },
                    maximumPressure: {
                        value: null,
                        units: null,
                    },
                    metallurgy: null,
                },
                filtration: {
                    type: null,
                    capacity: {
                        value: null,
                        units: null,
                        time: null,
                    },
                    filtrationLevel: {
                        value: null,
                        units: null,
                    },
                    openBassing: null,
                    expansionTank: null,
                },
                treatment: {
                    product: null,
                    injectionMethod: null,
                    pumpModel: null,
                    maxPressure: {
                        value: null,
                        units: null,
                    },
                    operation: null,

                },
                history: [],
            },
            data: {
                nodeInfo: null,
            },
            model: null,
        };
    },
    computed: {
        ...mapGetters([
            'activeTab',
            'site',
            'userLang',
            'hasPermission',
        ]),
        newActiveTab: {
            get() {
                return this.activeTab;
            },
            set(newValue) {
                this.$store.dispatch('changeActiveTab', newValue);
            },
        },
        readonly() {
            return !this.hasPermission('techFiles.edit');
        },
    },
    mounted() {
        window.addEventListener('beforeunload', this.handleUnload);
    },

    async created() {
        this.loading = true;
        this.$store.dispatch('changeActiveTab', 0);
        await this.getNodeInfo();
        if (!this.units) {
            await this.loadUnits({ siteId: this.site.id, lang: this.userLang });
        }
        this.model = this.data.nodeInfo ? this.data.nodeInfo : this.empty;
        this.tabs = this.tableHeaders();
        this.loading = false;
    },
    beforeDestroy() {
        if (this.node && this.node.ref) {
            lockService.releaseLock(this.node.ref, 'TechnicalFileCloseLoop');
        }
        window.removeEventListener('beforeunload', this.handleUnload);
    },
    methods: {
        ...mapActions({
            loadUnits: 'getUnits',
        }),
        async getNodeInfo() {
            const { data } = await this.$rq.getNodeInfo(this.site.id, this.node.ref, { closedLoopChild: true });
            if (Object.keys(data).length) this.data.nodeInfo = data;
        },
        handleUnload() {
            if (this.node && this.node.ref) {
                lockService.releaseLock(this.node.ref, 'TechnicalFileCloseLoop');
            }
        },
        tableHeaders() {
            const headers = this.components.map((component, index) => ({
                index,
                props: { ...this.model, siteId: this.site.id, readonly: this.readonly },
                name: this.$t(`technicalFile.closedLoop.step${index}.title`),
                component: Vue.component(`tab-${index}`, component),
            }));
            this.$store.dispatch('setTabs', headers);
            return headers;
        },
        updateData(newData) {
            this.model = { ...this.model, ...newData };
            this.$emit('sendData', this.model);
        },
    },
};
</script>
